import React,{ useContext, useEffect, useState } from "react"
import { API } from "../../../../API"
import { UiCtx } from "../../../../Context/Ui"
import {BsFillPlusCircleFill} from "react-icons/bs"
import {ImSpinner9} from "react-icons/im"

import {FaRegEdit} from "react-icons/fa"
import MedicalPlanSave from "../Save"
import MedicalPlanStatus from "../Components/Status"
import Policy from "Components/Policy"
import { PERMISO_VER_MEDICAL_PLAN,PERMISO_MODIFICAR_MEDICAL_PLAN,PERMISO_AGREGAR_MEDICAL_PLAN } from "Contants"

const MedicalPlanListProtected=()=>{
    const {showAlert} = useContext(UiCtx)
    const [items,setItems]=useState([])
    const [item,setItem]=useState(null)
    const [loading,setLoading] = useState(false)

    const load= async ()=>{
        try{
            setLoading(true)
            const {data} = await API('configuracion/tipo/')
            setItems(data)
        }catch(error){
            showAlert({icon:'error',html:error?.response?.data?.detail || error.toString()})
        }finally{
            setLoading(false)
        }
    }

    const onSave=(_item)=>{
        const exist = items.findIndex(i=>i.id==_item.id)

        if(exist>=0){
            setItems(prev=>(prev.map((i)=>{
                if(i.id==_item.id){
                    return _item
                }
                return i
            })))
        }else{
            setItems(prev=>[...prev,_item])
        }
    }

    useEffect(()=>{
        load()
    },[])

    return <div className="lg:w-[40%] md:w-[70%] sm:w-[90%] m-auto my-4">
        <Policy show_error={false} policies={[PERMISO_MODIFICAR_MEDICAL_PLAN,PERMISO_AGREGAR_MEDICAL_PLAN]}>
            <MedicalPlanSave item={item} setItem={setItem} onSave={onSave}/>
        </Policy>
        
        <div className="flex items-center justify-end mb-4">
            <button onClick={load} className="hover:bg-slate-400/40 rounded-md p-[4px] flex items-center mr-4">Recargar {loading && <ImSpinner9 className="ml-2 animate-spin"/>}</button>
            <Policy show_error={false} policies={[PERMISO_AGREGAR_MEDICAL_PLAN]}>
                <button onClick={()=>setItem({})} className="hover:bg-slate-400/40 rounded-md p-[4px] flex items-center">Nuevo plan médico <BsFillPlusCircleFill className="ml-2"/></button>
            </Policy>
            
        </div>
        <table className="border-[1px] border-slate-400/40">
            <thead className="bg-slate-400/40">
                <tr>
                    <th>Plan médico</th>
                    <th colSpan={2}></th>
                </tr>
            </thead>
            <tbody>
                {items.map((_item,index)=>(<tr>
                    <td>{_item.tipo}</td>
                    <td>  
                        <button className="hover:cursor-pointer hover:bg-slate-400/40 rounded-full p-[4px]">
                            <FaRegEdit size={16} onClick={()=>setItem(_item)}/>
                        </button>
                    </td>
                    <td>
                        <MedicalPlanStatus {..._item} onChange={onSave}/>
                    </td>
                </tr>))}
            </tbody>
        </table>
    </div>
}

const MedicalPlanList=()=>{
    return <Policy policies={[PERMISO_VER_MEDICAL_PLAN]}>
        <MedicalPlanListProtected/>
    </Policy>
}

export default MedicalPlanList